import covid_care from "../src/images/covid_care.jpg";
import chat from "../src/images/chat.png";
import teams from "../src/videos/teams.mp4";
import java from "../src/images/Skills/java.png";
import lang from "../src/images/Skills/c++.png";
import problemsolving from "../src/images/Skills/problemsolving.png";
import sql from "../src/images/Skills/SQL.png";
import react from "../src/images/Skills/react.png";
import redux from "../src/images/Skills/redux.png";
import sass from "../src/images/Skills/sass.png";
import mongodb from "../src/images/Skills/mongodb.png";
import firebase from "../src/images/Skills/firebase.png";
import html from "../src/images/Skills/html.png";
import css from "../src/images/Skills/css.png";
import javascript from "../src/images/Skills/javascript.png";
import node from "../src/images/Skills/node.png";
import express from "../src/images/Skills/express.png";
import bootstrap from "../src/images/Skills/bootstrap.png";
import vcovid_care from "../src/videos/covid care.mov";
import chatt from "../src/videos/chat.mov";
import thomas from "../src/images/thomas.png";
import files from "../src/images/file.png";
import file from "../src/videos/file.mov";
import microsoft from "../src/images/microsoft.png";
// Home Page
const home = [];
// About Page
const about = {
  about_data: [
    "I'm Komal Mahto, a 4th year Student pursuing Bachelors in Mathematics and Computing engineering at Delhi Technological University formerly DCE",
    "C++ Programmer | MERN Stack Developer | Competitive Programmer | Active Learner",
  ],
};
const navbar = {
  navbar_data: [
    ["/", "Home"],
    ["/education", "Education"],
    ["skill", "Skills"],
    ["/experience", "Experience"],
    ["/project", "Project"],
    ["/achievement", "Achievement"],
    ["/contactme", "Contact Me"],
  ],
};
//Education Page
const education = {
  edudata: [
    {
      title: "Delhi Technological University",
      imgsrc: "http://n-samarth.tech/assets/img/dtulogowhite.png",
      side: "timeline-content js--fadeInLeft left",
      date: "2019 - Present",
      content: [
        "Bachelor Of Technology, Mathematics And Computing",
        "CGPA, 8.21(upto 4th Sem)",
      ],
      link: "http://www.dtu.ac.in/",
    },
    {
      title: "Kendriya Vidyalaya CRPF, Lucknow",
      imgsrc:
        "https://4.bp.blogspot.com/-cKfxHZBZKNo/WIQaN1S0CwI/AAAAAAAAFAc/8CVg_TVmG6ES8uVepCpzzYmwKyxvmyR7gCLcB/s1600/kvs-logo-with-bg.png",
      side: "timeline-content js--fadeInLeft left",
      date: "[July 2018]",
      content: ["AISSCE(Class XII),CBSE", "Percentage: 88.45%"],
      link: "https://crpfbijnour.kvs.ac.in/",
    },
    {
      title: "ST.THOMAS COLLEGE, Lucknow",
      imgsrc: thomas,
      side: "timeline-content js--fadeInLeft left",
      date: "[]uly 2016]",
      content: ["AISCE(Class X),ICSE", "Percentage: 93%"],
      link: "http://www.stthomascollegelucknow.com/",
    },
  ],
};
// Work Experience

//skills
const skills = {
  skills_link: [
    {
      imgsrc: lang,
      title: "C++",
    },
    {
      imgsrc: javascript,
      title: "Javascript",
    },
    {
      imgsrc: java,
      title: "Java",
    },
    {
      imgsrc: problemsolving,
      title: "DS Algo",
    },
    {
      imgsrc: react,
      title: "React",
    },
    {
      imgsrc: redux,
      title: "Redux",
    },
    {
      imgsrc: node,
      title: "Node.js",
    },
    {
      imgsrc: express,
      title: "Express",
    },
    {
      imgsrc: mongodb,
      title: "mongoDB",
    },
    {
      imgsrc: sql,
      title: "SQL",
    },

    {
      imgsrc: firebase,
      title: "Firebase",
    },
    {
      imgsrc: sass,
      title: "SASS",
    },
    {
      imgsrc: bootstrap,
      title: "Bootstrap",
    },
    {
      imgsrc: "https://cdn.worldvectorlogo.com/logos/material-ui.svg",
      title: "Material UI",
    },
    {
      imgsrc: html,
      title: "Html5",
    },
    {
      imgsrc: css,
      title: "CSS3",
    },
  ],
};
//projects
const project = {
  project_data: [
    {
      imgsrc:
        "https://www.logo.wine/a/logo/Microsoft_Teams/Microsoft_Teams-Logo.wine.svg",
      title: "Microsoft Teams",
      stacks: [
        "https://img.shields.io/badge/-React-black?style=for-the-badge&labelColor=black&logo=react&logoColor=61DBFB",
        "https://img.shields.io/badge/-Redux-black?style=for-the-badge&labelColor=black&logo=redux&logoColor=B24080",
        "https://img.shields.io/badge/-MongoDB-black?style=for-the-badge&labelColor=black&logo=mongodb&logoColor=green",
        "https://img.shields.io/badge/-Express-black?style=for-the-badge&labelColor=black&logo=express&logoColor=61DBFB",
        "https://img.shields.io/badge/-Node.js-black?style=for-the-badge&labelColor=black&logo=node.js&logoColor=green",
        "https://img.shields.io/badge/-Html-black?style=for-the-badge&labelColor=black&logo=html5&logoColor=orange",
        "https://img.shields.io/badge/-Css-black?style=for-the-badge&labelColor=black&logo=css3&logoColor=yellow",
        "https://img.shields.io/badge/-Javascript-black?style=for-the-badge&labelColor=black&logo=javascript&logoColor=yellow",
        "https://img.shields.io/badge/-WebRTC-black?style=for-the-badge&labelColor=black",
      ],
      video: teams,
      Date: "July, 2021",
      content: [
        "Developed Microsoft Teams Clone under the guidance of mentors using Agile Methodology",
        "Chat with friends, send images, videos as well as play, download and watch in picture in picture mode and speech to text",
        "Video conference with friends, switch mic on/off, video on/off, present screen, chat while being on call and continue chatting after call",
        "Create notes, save and delete them",
        "User Authentication",
        "Implemented using Socket.io, Webrtc, Multer, Cloudinary, brcypt and Speech recognition",
        "Tech Stack - MERN(MongoDB, Express.js, React.js, Node.js)",
      ],
      live: "https://komalmahto-microsoft-teams.herokuapp.com/",
      github: "https://github.com/komalmahto/Microsoft-Engage-Project",
    },
    {
      imgsrc: covid_care,
      title: "Covid Care",
      stacks: [
        "https://img.shields.io/badge/-Html-black?style=for-the-badge&labelColor=black&logo=html5&logoColor=orange",
        "https://img.shields.io/badge/-Css-black?style=for-the-badge&labelColor=black&logo=css3&logoColor=yellow",
        "https://img.shields.io/badge/-Javascript-black?style=for-the-badge&labelColor=black&logo=javascript&logoColor=yellow",
        "https://img.shields.io/badge/-Node.js-black?style=for-the-badge&labelColor=black&logo=node.js&logoColor=green",
        "https://img.shields.io/badge/-MongoDB-black?style=for-the-badge&labelColor=black&logo=mongodb&logoColor=green",
        "https://img.shields.io/badge/-Express-black?style=for-the-badge&labelColor=black&logo=express&logoColor=61DBFB",
      ],
      video: vcovid_care,
      Date: "July, 2020",
      content: [
        "Users can be aware of nearby COVID patients. COVID patients can upload a post (multer/cloudinary) along with an image of a landmark /locality to alert other people",
        "Users can also see their danger zones by clicking on the filter buttons and they will also receive an email for further help using Nodemailer",
        "Backend for CRUD operations on Database(MongoDB)",
        "Covid Tracker , comment section, delete posts , speech to text , flash message for every users actions and created REST API in Node.js",
        "User Authentication and an admin panel is also set up for monitoring users' actions",
      ],
      live: "https://serene-fortress-06561.herokuapp.com/",
      github: "https://github.com/komalmahto/Covid-Care",
    },
    {
      imgsrc: chat,
      title: "Chat App",
      stacks: [
        "https://img.shields.io/badge/-Javascript-black?style=for-the-badge&labelColor=black&logo=javascript&logoColor=yellow",
        "https://img.shields.io/badge/-Html-black?style=for-the-badge&labelColor=black&logo=html5&logoColor=orange",
        "https://img.shields.io/badge/-Css-black?style=for-the-badge&labelColor=black&logo=css3&logoColor=yellow",
        "https://img.shields.io/badge/-Socket.io-black?style=for-the-badge&labelColor=black",
      ],
      video: chatt,
      Date: "March, 2020",
      content: [
        "Real time chat system using Socket.io",
        "Shows current location of user and a mic to convert speech to text.",
      ],
      live: "https://cryptic-tundra-23729.herokuapp.com/",
      github: "https://github.com/komalmahto/chatapp",
    },
    {
      imgsrc: files,
      title: "File Compressor",
      stacks: [
        "https://img.shields.io/badge/-Html-black?style=for-the-badge&labelColor=black&logo=html5&logoColor=orange",
        "https://img.shields.io/badge/-Css-black?style=for-the-badge&labelColor=black&logo=css3&logoColor=yellow",
        "https://img.shields.io/badge/-Javascript-black?style=for-the-badge&labelColor=black&logo=javascript&logoColor=yellow",
      ],
      video: file,
      Date: "June, 2020",
      content: [
        "Compress your text or decompress your compressed file using Huffman Coding Algorithm",
        "Implemented using Javascript, Html and Css.",
      ],
      live: "https://komalmahto.github.io/File-Compressor/",
      github: "https://github.com/komalmahto/File-Compressor",
    },
  ],
};
//Experience
const experience = {
  experience_data: [
    {
      title: "Software Engineering Intern, 2022",
      imgsrc: "https://pngimg.com/uploads/visa/visa_PNG36.png",
      side: "timeline-content js--fadeInRight right",
      class: "right",
      name: "Visa",
      date: "[9 May 2022 - 15 July 2022]",
      content: [
        "Used ansible as a DevOps tool to automate the deployment of the MERN web app to a virtual private server.",
        "Designed and developed an automated, scalable web portal in react.js to automate 25+ application maintenance services(start/stop/status/log retrieval, etc.) using ansible playbooks triggered through Nodejs backend.",
        "Integrated analytics to track activities on 25+ application servers and visualize data in a graphical format",
        "End to End Automation resulting in elimination of 95% of manual work.",
        "Tech stack  –  Ansible | Bash | VPS | Mysql | Node.js | React ",
      ],
      color: "linear-gradient(to bottom, #3B185F,#4E3D53)",
      detail: "",
    },
    {
      title: "Microsoft Engage Mentee",
      imgsrc: microsoft,
      side: "timeline-content js--fadeInRight right",
      class: "right",
      name: "Microsoft",
      date: "[9 Jun 2021 - 12 July 2021]",
      content: [
        "Developed Microsoft Teams Clone under the guidance of mentors using Agile Methodology",
        "Chat with friends, send images, videos as well as play, download and watch in picture in picture mode and speech to text",
        "Video conference with friends, switch mic on/off, video on/off, present screen, chat while being on call and continue chatting after call",
        "Create notes, save and delete them",
        "User Authentication",
        "Implemented using Socket.io, Webrtc, Multer, Cloudinary, brcypt and Speech recognition",
        "Tech Stack - MERN(MongoDB, Express.js, React.js, Node.js)",
      ],
      color: "linear-gradient(to bottom, #3C415C,#301B3F)",
      detail: "https://github.com/komalmahto/Microsoft-Engage-Project",
    },
    {
      title: "ReactJS Intern",

      side: "timeline-content js--fadeInRight right",
      class: "right",
      name: "YBox Media LLP",
      date: "[11 Oct 2021 - 10 Nov 2021]",
      content: [
        "Developed Frontend of IKC Play from scratch,clone of Quizando",
        "Redeveloped Polls,Petition,Awards section of Polbol",
        "https://quizando.netlify.app/",
        "https://amazing-swartz-d81da1.netlify.app/",
      ],

      color: "linear-gradient(to bottom, #5E366A,#331940)",
      detail: "https://github.com/komalmahto?tab=repositories",
    },
    {
      title: "Web Development Intern",
      imgsrc: "https://cdn.razorpay.com/logos/CH1RON2DtjDaRL_large.png",
      side: "timeline-content js--fadeInRight right",
      class: "right",
      name: "Samagra Foundation",
      date: "[5 Aug 2020 - 4 Sep 2020]",
      content: [
        "Responsible for designing UI , backend for CRUD operations on Database(mongoDB) and created REST API in Node.js.",
        "Successfully solved the problem of fundraising and admin panel.",
        "https://samagrafoundation.com",
      ],
      color: "linear-gradient(to bottom, #450c6e,#4E3D53)",
      detail: "https://samagrafoundation.com",
    },
  ],
};
//Achievements

const achievement = {
  achievement_data: [
    "Among the top 7 teams, shortlisted for AP Global Case Regional Finals in Visa(Internal Idea Submission Hackathon)",
    "Solved 570+ problems on geeksforgeeks/leetcode/codeforces/codechef",
    "Achieved a Global Rank of 114 in Codechef December Long Challenge 2020",
    "Achieved 3rd Position in DevWeek Hakathon 2020",
    "The Prime Minister Scholarship Scheme (PMSS) holder 2020 & 2021",
    "Successfully contributed in HacktoberFest and 80% of my pull requests got merged.",
  ],
};

const connect = {
  connect_data: [
    ["fa fa-phone", "Phone"],
    ["fa fa-envelope", "komalmahto.dtu@gmail.com"],
    ["fa fa-map-marker", "Lucknow,Uttar Pradesh"],
  ],
};

const links = {
  links_data: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/komal-mahto-14912319b/",
      className: "fa fa-linkedin ",
    },
    {
      name: "github",
      url: "https://github.com/komalmahto/",
      className: "fa fa-github",
    },
    {
      name: "twitter",
      url: "https://twitter.com/KomalMahto11",
      className: "fa fa-twitter ",
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/snorlax_022/",
      className: "fa fa-instagram",
    },
  ],
};

export {
  home,
  about,
  education,
  skills,
  project,
  achievement,
  connect,
  links,
  experience,
  navbar,
};
